import { DatePipe } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { DprWeatherDetailReport, DprWeatherReport } from '@report/models';
import { StaticMessage } from '@shared/enums';
import { DataType, SelectionItem } from '@shared/models';
import { DprWeather, DprWeatherDetail } from '@shared/models/dpr';
import {
  SubprojectConfigurationCustomNames,
  Weather,
  WeatherValue,
} from '@shared/models/project-setup';
import { SortPipe } from '@shared/pipes';
import {
  buildBooleanValues,
  convertTimeToDisplayFormat,
  getValue,
} from '@shared/utils';
import cloneDeep from 'lodash.clonedeep';

@Component({
  selector: 'app-report-weather',
  templateUrl: './report-weather.component.html',
  styleUrls: ['./report-weather.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportWeatherComponent implements OnInit {
  @Input({ required: true }) weatherList: Weather[];
  @Input({ required: true }) weatherDataTypeValueList: WeatherValue[];
  @Input({ required: true }) dprWeather: DprWeather;
  @Input({ required: true }) customNames: SubprojectConfigurationCustomNames;

  weatherReport: DprWeatherReport = {
    weatherDetailReport: [],
    columnWidth: 0,
    columnNumber: 0,
  };

  StaticMessage = StaticMessage;

  constructor(private sortPipe: SortPipe, private datePipe: DatePipe) {}

  ngOnInit(): void {
    const dprWeatherDetails: DprWeatherDetail[] = this.sortPipe.transform(
      cloneDeep(this.dprWeather.dprWeatherDetails),
      'time'
    );
    dprWeatherDetails.forEach((dprWeatherDetail) => {
      const toAdd: DprWeatherDetailReport = {
        time: convertTimeToDisplayFormat(`${dprWeatherDetail.time}`),
        dprWeatherDetailsItems: [],
      };

      this.weatherList.forEach((weather) => {
        const detail = (dprWeatherDetail.dprWeatherDetailsItems || []).find(
          (x) => x.weatherId === weather.id
        );

        let listOptions: SelectionItem[];

        switch (weather.dataTypeId) {
          case DataType.List:
            listOptions = cloneDeep(this.weatherDataTypeValueList)
              .filter((w) => w.weatherId === weather.id)
              .map((v) => ({ id: v.id, name: v.value }));
            break;
          case DataType.Boolean:
            listOptions = buildBooleanValues(weather.booleanTerminologyId).map(
              (x) => ({ id: x.id, name: x.value })
            );
            break;
          default:
            listOptions = [];
        }

        toAdd.dprWeatherDetailsItems.push({
          value: detail
            ? `${getValue(
                detail.value,
                weather.dataTypeId,
                listOptions,
                this.datePipe
              )}`
            : '-',
        });
      });

      this.weatherReport.weatherDetailReport.push(toAdd);
    });

    // Plus 2 is to account for the sequence column
    this.weatherReport.columnWidth = 100 / (this.weatherList.length + 2);
    this.weatherReport.columnNumber = this.weatherList.length + 2;
  }
}
